import { render, staticRenderFns } from "./goodsSwipe.vue?vue&type=template&id=d98a1940&scoped=true"
import script from "./goodsSwipe.vue?vue&type=script&lang=ts"
export * from "./goodsSwipe.vue?vue&type=script&lang=ts"
import style0 from "./goodsSwipe.vue?vue&type=style&index=0&id=d98a1940&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d98a1940",
  null
  
)

export default component.exports